import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

const services = [
  {
    name: 'Bioklimatik Pergola',
    slug: 'bioklimatik-pergola',
    image: 'https://public.readdy.ai/ai/img_res/f49dcc0358263a7db8991510ac7ec2bc.jpg',
    description: 'Lüks ve teknolojik pergola sistemleri',
  },
  {
    name: 'Körüklü Tente',
    slug: 'koruklu-tente',
    image: 'https://readdy.ai/api/search-image?query=Professional%20retractable%20folding%20arm%20awning%20system%20mounted%20on%20modern%20building%20facade%20with%20durable%20weatherproof%20fabric%20in%20neutral%20beige%20tone%2C%20sturdy%20aluminum%20framework%2C%20commercial%20grade%20quality%2C%20elegant%20curved%20design%2C%20clean%20simple%20background%20highlighting%20the%20awning%20structure&width=600&height=700&seq=kor1&orientation=portrait',
    description: 'Esnek ve dayanıklı gölgelendirme',
  },
  {
    name: 'Mafsallı Tente',
    slug: 'mafsalli-tente',
    image: 'https://readdy.ai/api/search-image?query=High%20quality%20articulated%20joint%20awning%20with%20robust%20mechanical%20arm%20system%2C%20premium%20weather%20resistant%20striped%20canvas%20in%20classic%20colors%2C%20professional%20installation%20on%20residential%20terrace%2C%20traditional%20elegant%20style%2C%20reinforced%20metal%20framework%2C%20simple%20light%20background%20showcasing%20the%20awning%20details&width=600&height=650&seq=maf1&orientation=portrait',
    description: 'Klasik ve şık tente çözümleri',
  },
];

const features = [
  {
    title: '15+ Yıl Deneyim',
    description: 'Bursa genelinde binlerce başarılı proje',
    stat: '2500+',
    statLabel: 'Mutlu Müşteri',
  },
  {
    title: 'Garantili Montaj',
    description: 'Profesyonel ekip ve kaliteli malzeme garantisi',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Ücretsiz Keşif',
    description: 'Yerinde inceleme ve detaylı fiyat teklifi',
    icon: 'ri-search-eye-line',
  },
];

const testimonials = [
  {
    name: 'Mehmet Yılmaz',
    location: 'Nilüfer, Bursa',
    rating: 5,
    text: 'Bioklimatik pergola montajımızı Bursa Tente yaptı. Hem kalitesi hem de fiyatı çok uygundu. Bahçemiz tam bir yaşam alanına dönüştü. Ekip son derece profesyonel ve işlerini titizlikle yapıyorlar.',
  },
  {
    name: 'Ayşe Demir',
    location: 'Osmangazi, Bursa',
    rating: 5,
    text: 'Körüklü tente için araştırırken Bursa Tente ile tanıştık. Ürün kalitesi ve montaj hizmeti harika. Balkonumuz artık her mevsim kullanılabilir hale geldi. Kesinlikle tavsiye ediyorum.',
  },
  {
    name: 'Ahmet Kaya',
    location: 'Yıldırım, Bursa',
    rating: 5,
    text: 'Cafe için otomatik pergola sistemini tercih ettik. Müşterilerimiz çok memnun. Hava durumuna göre ayarlanabiliyor ve çok pratik. Bursa Tente ekibine teşekkürler.',
  },
];

export default function Home() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (imageSrc: string) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  const services = [
    {
      icon: 'ri-tent-line',
      name: 'Körüklü Tente',
      description: 'Esnek kol mekanizması ile kolay kullanım',
      slug: 'koruklu-tente',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/cabfb2b171a0f02fec5e186c7450ff16.png',
    },
    {
      icon: 'ri-building-line',
      name: 'Mafsallı Tente',
      description: 'Klasik ve zarif tasarım',
      slug: 'mafsalli-tente',
      image: 'https://readdy.ai/api/search-image?query=High%20quality%20articulated%20joint%20awning%20with%20robust%20mechanical%20arm%20system%2C%20premium%20weather%20resistant%20striped%20canvas%20in%20classic%20colors%2C%20professional%20installation%20on%20residential%20terrace%2C%20traditional%20elegant%20style%2C%20reinforced%20metal%20framework%2C%20simple%20light%20background%20showcasing%20the%20awning%20details&width=400&height=300&seq=maf2&orientation=landscape',
    },
    {
      icon: 'ri-compass-line',
      name: 'Otomatik Pergola',
      description: 'Akıllı motor sistemi ile kontrol',
      slug: 'otomatik-pergola',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/ff193db8c6ee32d0b64162a4491bed92.png',
    },
    {
      icon: 'ri-home-gear-line',
      name: 'Bioklimatik Pergola',
      description: 'Ayarlanabilir lamel sistemi',
      slug: 'bioklimatik-pergola',
      image: 'https://readdy.ai/api/search-image?query=Modern%20bioclimatic%20pergola%20system%20installed%20in%20a%20luxury%20outdoor%20living%20space%20with%20motorized%20rotating%20louvers%20providing%20adjustable%20shade%20control%2C%20featuring%20sleek%20aluminum%20frame%20in%20anthracite%20gray%20finish%2C%20integrated%20LED%20lighting%20strips%2C%20clean%20minimalist%20design%2C%20contemporary%20architectural%20style%2C%20simple%20light%20neutral%20background%20emphasizing%20the%20structure&width=400&height=300&seq=bio2&orientation=landscape',
    },
    {
      icon: 'ri-landscape-line',
      name: 'Zip Perde',
      description: 'Rüzgar geçirmez yan ray sistemi',
      slug: 'zip-perde',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/48ac3939e61f0dbaa2b1b53cc30358d6.jpeg',
    },
    {
      icon: 'ri-shield-line',
      name: 'Şeffaf Stor',
      description: 'Manzarayı koruyarak hava perdesi',
      slug: 'seffaf-stor',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/037fad47e2fe181b92aebf396e0acb20.webp',
    },
    {
      icon: 'ri-store-line',
      name: 'Fransız Tente',
      description: 'Klasik Avrupa estetiği',
      slug: 'fransiz-tente',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/38c3491ffaccb66b24e7c806b18477ec.png',
    },
    {
      icon: 'ri-inbox-line',
      name: 'Kasetli Tente',
      description: 'Tam kapalı koruma kasası',
      slug: 'kasetli-tente',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/9c05db707225360dbe425359092559a4.png',
    },
    {
      icon: 'ri-instance-line',
      name: 'Karpuz Tente',
      description: 'Geleneksel kubbe tasarımı',
      slug: 'karpuz-tente',
      image: 'https://readdy.ai/api/search-image?query=Dome%20shaped%20watermelon%20style%20awning%20with%20curved%20semicircular%20design%2C%20striped%20colorful%20fabric%20pattern%2C%20traditional%20commercial%20storefront%20installation%2C%20rounded%20protective%20canopy%2C%20classic%20Mediterranean%20style%2C%20simple%20background%20showcasing%20the%20curved%20awning%20shape&width=400&height=300&seq=kar2&orientation=landscape',
    },
    {
      icon: 'ri-layout-grid-line',
      name: 'T Modül Tente',
      description: 'Modüler ve genişletilebilir yapı',
      slug: 't-modul-tente',
      image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/9afa341389428a0904540c32aed58d2e.png',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20luxury%20outdoor%20living%20space%20with%20elegant%20pergola%20and%20awning%20systems%20creating%20sophisticated%20shaded%20terrace%20area%2C%20featuring%20contemporary%20aluminum%20structures%2C%20premium%20fabric%20canopy%2C%20comfortable%20designer%20furniture%20beneath%2C%20architectural%20excellence%2C%20serene%20residential%20setting%20with%20lush%20greenery%2C%20professional%20installation%20quality%2C%20clean%20minimalist%20aesthetic%2C%20warm%20natural%20lighting&width=1920&height=1080&seq=hero1&orientation=landscape"
            alt="Bursa Tente Modern Pergola Sistemleri"
            className="w-full h-full object-cover object-top cursor-pointer"
            loading="eager"
            onClick={() => openLightbox('https://readdy.ai/api/search-image?query=Modern%20luxury%20outdoor%20living%20space%20with%20elegant%20pergola%20and%20awning%20systems%20creating%20sophisticated%20shaded%20terrace%20area%2C%20featuring%20contemporary%20aluminum%20structures%2C%20premium%20fabric%20canopy%2C%20comfortable%20designer%20furniture%20beneath%2C%20architectural%20excellence%2C%20serene%20residential%20setting%20with%20lush%20greenery%2C%20professional%20installation%20quality%2C%20clean%20minimalist%20aesthetic%2C%20warm%20natural%20lighting&width=1920&height=1080&seq=hero1&orientation=landscape')}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 text-center text-white">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-7xl font-bold mb-3 md:mb-6 leading-tight">
            Bursa'nın Modern Tente ve<br />Pergola Uzmanı
          </h1>
          <p className="text-sm sm:text-base md:text-xl lg:text-2xl mb-4 md:mb-8 text-gray-100 max-w-3xl mx-auto">
            15+ yıldır Bursa genelinde estetik, dayanıklı ve uzun ömürlü gölgelendirme sistemleri sunuyoruz
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://wa.me/905421821925?text=Merhaba,%20tente%20ve%20pergola%20sistemleri%20hakkında%20bilgi%20almak%20istiyorum"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-secondary text-white px-5 md:px-8 py-2.5 md:py-4 rounded-full text-sm md:text-lg font-bold hover:bg-secondary/90 transition-all shadow-lg flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-lg md:text-2xl"></i>
              Ücretsiz Teklif Alın
            </a>
            <a
              href="tel:+905421821925"
              className="border-2 border-white text-white px-5 md:px-8 py-2.5 md:py-4 rounded-full text-sm md:text-lg font-bold hover:bg-white hover:text-primary transition-all shadow-lg flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-lg md:text-2xl"></i>
              Hemen Arayın
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="py-8 md:py-16 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-6 md:mb-12 gap-4">
            <div>
              <h3 className="text-2xl md:text-4xl font-bold text-primary mb-2">Hizmetlerimiz</h3>
              <p className="text-sm md:text-base text-gray-600">Profesyonel tente ve pergola çözümleri</p>
            </div>
            <Link
              to="/hizmetler"
              className="text-secondary font-semibold flex items-center gap-2 hover:gap-3 transition-all cursor-pointer text-sm md:text-base"
            >
              Tümünü Gör
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {services.map((service) => (
              <Link
                key={service.slug}
                to={`/hizmetler/${service.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-32 md:h-40 overflow-hidden">
                  <img
                    src={service.image}
                    alt={`Bursa ${service.name}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 cursor-pointer"
                    loading="lazy"
                    onClick={(e) => {
                      e.preventDefault();
                      openLightbox(service.image);
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                </div>
                <div className="p-3 md:p-4">
                  <h4 className="text-sm md:text-base font-bold text-primary mb-1 group-hover:text-secondary transition-colors">
                    {service.name}
                  </h4>
                  <p className="text-xs text-gray-600 line-clamp-2">{service.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 md:py-20">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row justify-between items-start mb-8 md:mb-16 gap-6">
            <h3 className="text-3xl md:text-5xl font-serif font-bold text-primary">Neden Bursa Tente?</h3>
            <p className="text-sm md:text-base text-gray-600 max-w-xl">
              15 yılı aşkın deneyimimiz ve binlerce mutlu müşterimizle Bursa'nın güvenilir tente ve pergola markasıyız.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-6 md:gap-8">
            {/* Dark Card */}
            <div className="bg-primary rounded-3xl p-6 md:p-8 text-white space-y-4 md:space-y-6">
              <h4 className="text-xl md:text-2xl font-bold">{features[0].title}</h4>
              <p className="text-sm md:text-base text-gray-300">{features[0].description}</p>
              <div className="text-4xl md:text-6xl font-bold my-6 md:my-8">{features[0].stat}</div>
              <p className="text-base md:text-lg text-gray-300">{features[0].statLabel}</p>
              <Link
                to="/yorumlar"
                className="inline-block border-2 border-white text-white px-5 md:px-6 py-2.5 md:py-3 rounded-full text-xs md:text-sm font-semibold hover:bg-white hover:text-primary transition-all whitespace-nowrap cursor-pointer"
              >
                Referanslar
              </Link>
            </div>

            {/* Light Cards */}
            {features.slice(1).map((feature, index) => (
              <div key={index} className="bg-white rounded-3xl p-6 md:p-8 shadow-md hover:shadow-xl transition-shadow space-y-4 md:space-y-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  Aktif Garanti
                </div>
                <div className="w-full h-36 md:h-48 rounded-2xl overflow-hidden bg-gray-100 cursor-pointer" onClick={() => openLightbox(index === 0 ? 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/114b6132b0dbb809b07da379ad27b4a1.jpeg' : 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/cd389391d371bf676915ade375acd7e4.jpeg')}>
                  <img
                    src={index === 0 ? 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/114b6132b0dbb809b07da379ad27b4a1.jpeg' : 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/cd389391d371bf676915ade375acd7e4.jpeg'}
                    alt={feature.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <h4 className="text-lg md:text-xl font-bold text-primary">{feature.title}</h4>
                <p className="text-xs md:text-sm text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="grid lg:grid-cols-5 gap-8 md:gap-12 items-center">
            {/* Left Image */}
            <div className="lg:col-span-2">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl h-64 md:h-auto cursor-pointer" onClick={() => openLightbox('https://readdy.ai/api/search-image?query=Happy%20family%20enjoying%20their%20new%20modern%20pergola%20system%20in%20backyard%2C%20satisfied%20customers%20smiling%20under%20elegant%20awning%2C%20lifestyle%20photography%2C%20warm%20natural%20lighting%2C%20comfortable%20outdoor%20living%2C%20testimonial%20style%20image%2C%20simple%20background&width=600&height=800&seq=test1&orientation=portrait')}>
                <img
                  src="https://readdy.ai/api/search-image?query=Happy%20family%20enjoying%20their%20new%20modern%20pergola%20system%20in%20backyard%2C%20satisfied%20customers%20smiling%20under%20elegant%20awning%2C%20lifestyle%20photography%2C%20warm%20natural%20lighting%2C%20comfortable%20outdoor%20living%2C%20testimonial%20style%20image%2C%20simple%20background&width=600&height=800&seq=test1&orientation=portrait"
                  alt="Bursa Tente Mutlu Müşterileri"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="lg:col-span-3 space-y-6 md:space-y-8">
              <div>
                <p className="text-xs md:text-sm text-gray-500 mb-2">(Müşteri Görüşleri)</p>
                <h3 className="text-3xl md:text-5xl font-bold text-primary mb-2">Müşterilerimiz</h3>
                <h4 className="text-3xl md:text-5xl font-normal text-gray-600">Ne Diyor?</h4>
              </div>

              <div className="space-y-4 md:space-y-6">
                <div className="flex gap-1 text-lg md:text-2xl text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                
                <p className="text-sm md:text-xl text-gray-700 leading-relaxed">
                  "{testimonials[0].text}"
                </p>
                
                <div>
                  <p className="text-base md:text-xl font-bold text-primary">— {testimonials[0].name}</p>
                  <p className="text-xs md:text-sm text-gray-500">{testimonials[0].location}</p>
                </div>
              </div>

              <div className="flex gap-4">
                <button
                  className="w-10 h-10 md:w-12 md:h-12 border border-gray-300 rounded-full flex items-center justify-center hover:border-primary transition-colors cursor-pointer"
                  aria-label="Önceki yorum"
                >
                  <i className="ri-arrow-left-line text-gray-600"></i>
                </button>
                <button
                  className="w-10 h-10 md:w-12 md:h-12 bg-primary text-white rounded-full flex items-center justify-center hover:bg-primary/90 transition-colors cursor-pointer"
                  aria-label="Sonraki yorum"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 md:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20team%20installing%20modern%20bioclimatic%20pergola%20system%20on%20luxury%20residential%20property%2C%20skilled%20workers%20on%20site%20during%20installation%20process%2C%20high%20quality%20construction%20work%2C%20detailed%20craftsmanship%2C%20outdoor%20installation%20scene%2C%20architectural%20photography%2C%20soft%20natural%20daylight%2C%20simple%20background&width=1920&height=800&seq=cta1&orientation=landscape"
            alt="Bursa Tente Profesyonel Montaj Ekibi"
            className="w-full h-full object-cover cursor-pointer"
            loading="lazy"
            onClick={() => openLightbox('https://readdy.ai/api/search-image?query=Professional%20team%20installing%20modern%20bioclimatic%20pergola%20system%20on%20luxury%20residential%20property%2C%20skilled%20workers%20on%20site%20during%20installation%20process%2C%20high%20quality%20construction%20work%2C%20detailed%20craftsmanship%2C%20outdoor%20installation%20scene%2C%20architectural%20photography%2C%20soft%20natural%20daylight%2C%20simple%20background&width=1920&height=800&seq=cta1&orientation=landscape')}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-[1400px] mx-auto px-6 text-center text-white">
          <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-extrabold mb-3 md:mb-6 tracking-wide uppercase leading-tight">
            ÜCRETSİZ KEŞİF VE TEKLİF
          </h3>
          <p className="text-sm md:text-xl mb-2 md:mb-4 max-w-2xl mx-auto">
            Uzman ekibimiz size en uygun çözümü sunar
          </p>
          <p className="text-sm md:text-xl mb-6 md:mb-10 max-w-2xl mx-auto">
            Hemen iletişime geçin, fark edin
          </p>
          
          <a
            href="https://wa.me/905421821925?text=Merhaba,%20ücretsiz%20keşif%20ve%20teklif%20almak%20istiyorum"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 md:gap-4 bg-black text-white px-6 md:px-10 py-3 md:py-5 rounded-full text-sm md:text-lg font-bold hover:bg-black/90 transition-all shadow-2xl cursor-pointer"
          >
            <div className="w-8 h-8 md:w-10 md:h-10 bg-orange-500 rounded-full flex items-center justify-center">
              <i className="ri-whatsapp-fill text-base md:text-xl"></i>
            </div>
            HEMEN TEKLİF AL
            <i className="ri-arrow-right-up-line text-base md:text-xl"></i>
          </a>
        </div>
      </section>

      <Footer />
      <CookieBanner />

      {/* Floating Action Buttons - SAĞ ALT KÖŞE SABİT */}
      <div className="fixed right-4 md:right-6 bottom-4 md:bottom-6 z-50 flex flex-col gap-3">
        <a
          href="https://wa.me/905421821925?text=Merhaba,%20tente%20ve%20pergola%20sistemleri%20hakkında%20bilgi%20almak%20istiyorum"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-secondary text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform cursor-pointer"
          aria-label="WhatsApp ile iletişim"
        >
          <i className="ri-whatsapp-fill text-2xl"></i>
        </a>
        <a
          href="tel:+905421821925"
          className="w-14 h-14 bg-primary text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform cursor-pointer"
          aria-label="Telefon ile ara"
        >
          <i className="ri-phone-fill text-2xl"></i>
        </a>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors"
            onClick={closeLightbox}
            aria-label="Kapat"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görsel"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}